import React from "react";
import InternalPageHeader from "../../components/media/InternalPageHeader";
import { Col, Container, Row } from "react-bootstrap";
import TitleTextArticle from "../../components/text/TitleTextArticle";
// import ArticleText from '../../components/text/ArticleText';
import MediumFeaturedImg from "../../components/media/MedFeaturedImg";
import MediumFeaturedImgAlt from "../../components/media/MedFeaturedImgAlt";
import soilBanner from '../../images/soilexhibitLayer1.jpg';
import soilExhibit from '../../images/soilexhibitsm.jpg';
import soilExhibit2 from '../../images/soilExhibit2.jpg';
import quiltExhibit from '../../images/quiltexhibit.jpg';
import quiltExhibitsm from '../../images/quiltExhibitsm.jpg';
import Footer from "../../components/Footer";
const SoilExhibitPage = () =>{


return(
    <main className="memorialQuilts">
    <InternalPageHeader
      pageHeading={"Soil Collection Jar Exhibit"}
      pageSubHeading={"Memorializing Victims of Racial Injustice"}
      inPageBGImage={soilBanner}
    />


 <TitleTextArticle h3TitleText={"Truth & Reconciliation: The ACCRP & EJI"} />
<div className="articleText">
          <Container>
            <Row>
              <Col className="hold-article">
                <p className="articleText">
              
The Alachua County Community Remembrance Project (ACCRP) is a coalition of local community groups dedicated to working for Truth and Reconciliation.
                </p>
                <p className="articleText">
                The Equal Justice Initiative
(EJI) is a national organization
devoted to racial justice and
criminal justice reform. In
2015, they created the Soil
Collection Project to provide tangible opportunities for communities to confront history and the ongoing legacy of racial terrorism.
                </p>
                <p className="articleText">
                In 2020, the Alachua County Community Remembrance Project partnered with the Equal Justice Initiative. Together, they have documented nearly 50 lynchings in our county. Following EJI’s model, the ACCRP collects soil from or near lynching sites in our community. After the soil collection, they organize remembrance services for victims. The ACCRP continues to hold public educational events to educate our community about the history and legacies of racial terrorism.
                </p>
                <p>
                Together, the ACCRP and EJI have organized soil collection ceremonies and installed historical markers to commemorate victims.
                </p>
              </Col>
            </Row>
          </Container>
          <div className="articleText">
          <Container>
            <Row>
              <Col className="hold-article">
                <p className="articleText">
                  “In the soil, there is the sweat of the enslaved. In the soil there is the blood of the victims of racial violence and lynching. There are tears in the soil from all those who labored under the indignation and humiliation of segregation. But in the soil there is also the opportunity for new life, a chance to grow something hopeful and healing for the future” <br />
                <p>  &#8212;{" "}Bryan Stevenson, Executive Director, Equal Justice Initiative</p>
                </p>
                <MediumFeaturedImgAlt imgSrc={soilExhibit2} imgAlt={"Image of Soil Jar Exhibit"} />
                </Col>
            </Row>
          </Container>
        </div>
        </div>
        <TitleTextArticle h3TitleText={"Lynching in Alachua County"} />
<div className="articleText">
          <Container>
            <Row>
              <Col className="hold-article">
                <p className="articleText">
                The end of the Civil War marked the end of Slavery in the United States. This new
era of Reconstruction began with great hope for newly freedmen and women. Black citizens overcame enormous obstacles to pursue civic engagement, leadership roles, and educational opportunities. But many White people remained resistant to Black equality. And, as the nation approached its first election following Emancipation, White communities increasingly resorted to racial terror and mob violence to suppress Black voters and deny their rights as full citizens.
                </p>
                <p className="articleText">
                Between 1882 and 1930, Florida had the highest per capita lynching rate in the United States, with Alachua County ranked at the top of the list. There are nearly
50 documented lynchings of men, women, and children in our county. White mobs lynched Black people for voting, to take their property, or simply to instill terror
and intimidation. Racial terror lynchings were not the actions of a few extremists. Rather, they were bold, public acts that implicated the entire White community. After lynchings took place, these acts of terrorism were further reinforced as White officials and community members failed to hold mobs accountable for their crimes. They also did not work to prevent future violence. 
                </p>
                <p className="articleText">
                This exhibit honors the victims of racial terror lynching in Alachua County. By addressing this history, we can move toward truth, reconciliation, and racial equality.
                </p>


        
                 


                <MediumFeaturedImgAlt
                
          imgSrc={quiltExhibitsm}
          imgAlt={"Image of a Quilt in the Soil Collection Exhibit"}
        />
              </Col>
            </Row>
          </Container>
         
        </div>

        <TitleTextArticle h3TitleText={"Legacy Wood"} />
<div className="articleText">
          <Container>
            <Row>
              <Col className="hold-article">
                <p className="articleText">
                When Union soldiers withdrew their protection in the Southern states at the end of Reconstruction, state legislators passed “Jim Crow” laws to re-assert control over Black citizens. Black men and women were arrested for minor offenses such as “loitering” and forced into an exploitive convict leasing system which functioned just like slavery of the plantation era.
                </p>
                <p className="articleText">
                Florida’s long leaf pine forests were harvested for turpentine and lumber almost to extinction using this forced prison labor. The lumber was transported by river boats to the sawmills at the turn of the
20th century. This cabinet that holds our remembrance jars is built from heart wood pine from logs that fell into the rivers during this period of “second slavery.” The woods were salvaged by scuba divers for the Goodwin Lumber Company.
                </p>
                <p className="articleText">
                We use this legacy wood to honor the Black workers who built our nation’s wealth.
                </p>
                <p className="articleText">
               The Cabinet for this Exhibit was built by Akira Wood
                </p>
        
              </Col>
            </Row>
          </Container>
        </div>



     

        <TitleTextArticle h3TitleText={"Unknown Victims"} />
        
<div className="articleText">
          <Container>
            <Row>
              <Col className="hold-article">
                <p className="articleText">
                Lynchings were widely unreported in the White media. Newspapers and court records give some insight into the deaths of these individuals but tell nothing about who they were in life. In some cases, newspapers did not even report the names of the people they wrote about. More often than not, victims were identified only by the color of their skin.
                </p>
                <p className="articleText">
                We will never know the actual number of lynchings in Alachua County. Their names and stories have been intentionally erased. But we will remember and mourn the Black men, women, and children whose lives were lost to racial terrorism. We honor them with a jar marked “Unknown.”
                </p>
        
              </Col>
            </Row>
          </Container>
         
        </div>
               
        <TitleTextArticle h3TitleText={"Legacy of Racial Terrorism Today"} />
        <div className="articleText">
          <Container>
            <Row>
              <Col className="hold-article">
                <p className="articleText">
                The history of racial terrorism in the
United States is difficult and painful.
It forced the exodus of millions of
Black people from the South into
urban ghettos of the North and
West. It has also created a legacy of
racial inequality that has never been
adequately addressed and continues
to sustain racial injustice and bias.
                </p>
                <p className="articleText">
                The legacy of racial terrorism has also
sustained persistent racial disparities
here in Alachua county. Almost 50% of
our Black children live in poverty. The
average income for Black people in our
county is half that of White people.
Black people make up 70% of those
incarcerated in Alachua County jails,
despite being only 20% of our total
population. As the first step toward
recovery and reconciliation, we publicly
confront this shameful history by
acknowledging it. This space is a part
of that process. We invite visitors
to sit, reflect, mourn, and to work for
equity and justice
                </p>
        
              </Col>
            </Row>
          </Container>
         
        </div>


    <Footer />
  </main>
)


}

export default SoilExhibitPage;